module.exports = __webpack_public_path__ + "img/melhores-ideias.97a869f9.png";